"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getLocaleFromPreferences = _interopRequireDefault(require("./getLocaleFromPreferences"));
const getShowHomepageToggle = data => {
  if (!data.preferences || !data.user || !data.application || data.user.type !== 'GenesisHome') {
    return false;
  }
  const locale = (0, _getLocaleFromPreferences.default)(data);
  const {
    toggles: list
  } = data.application;
  const toggles = list.reduce((result, current) => ({
    ...result,
    [current.name]: current.isOn
  }), {});
  if (!toggles.IsToggleToNewHomeEnabled) {
    return false;
  }
  const {
    isNewHomeUser,
    isInternal,
    isLNGReportUser
  } = data.user;
  if (toggles.IsR3ToggleEnabled) {
    return isInternal && !isNewHomeUser;
  }
  if (toggles.IsR2ToggleEnabled) {
    return (!isLNGReportUser || isInternal) && !isNewHomeUser;
  }
  return isInternal && locale !== 'zh' && !isNewHomeUser;
};
var _default = exports.default = getShowHomepageToggle;